import { render } from "./AfterSaleForm.vue?vue&type=template&id=0e0c95e0&scoped=true"
import script from "./AfterSaleForm.vue?vue&type=script&lang=js"
export * from "./AfterSaleForm.vue?vue&type=script&lang=js"

import "./AfterSaleForm.vue?vue&type=style&index=0&id=0e0c95e0&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0c95e0"]])

export default __exports__